var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    viewBox: "352.05 341.02 305.96 305.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000011750850000381396440000011758937648767349669_);}\r\n\t.st2{fill:url(#SVGID_00000011026223393214615570000009993368381947353760_);}\r\n\t.st3{fill:url(#SVGID_00000013152263568405926370000012775756196831287461_);}\r\n\t.st4{fill:#403C29;}\r\n\t.st5{fill:url(#SVGID_00000158012972567508088180000003720132184533076399_);}\r\n\t.st6{fill:url(#SVGID_00000027586647753429256310000012803589334445667006_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 674.8232,
    y1: 494,
    x2: 281.5772,
    y2: 494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FED702"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAA00"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M658.01,494c0,84.49-68.49,152.98-152.98,152.98S352.05,578.49,352.05,494s68.49-152.98,152.98-152.98      S658.01,409.51,658.01,494z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181801598888117104940000011794479807253778111_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.0312,
    y1: 559.7388,
    x2: 505.0312,
    y2: 320.658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF0A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    style: {
      stopColor: "#FED702"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF4D1E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181801598888117104940000011794479807253778111_)"
    },
    d: "M505.03,356.7      c-74.75,0-135.34,60.6-135.34,135.34c0,74.74,60.6,135.34,135.34,135.34c74.75,0,135.34-60.6,135.34-135.34      C640.37,417.29,579.78,356.7,505.03,356.7z M373.61,492.04c0-72.47,58.96-131.43,131.42-131.43      c72.47,0,131.42,58.96,131.42,131.43c0,72.47-58.96,131.42-131.42,131.42C432.57,623.46,373.61,564.51,373.61,492.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070833370013103037630000006318400569368121234_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.1231,
    y1: 591.2954,
    x2: 506.1231,
    y2: 489.3932
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FED702"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAA00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070833370013103037630000006318400569368121234_)"
    },
    d: "M440.49,524.25      c-22.55,0-44.29-2.99-64.7-8.53c11.19,61.19,64.86,107.74,129.24,107.74c72.47,0,131.42-58.96,131.42-131.42      c0-20.09-4.55-39.13-12.64-56.18C586.16,488.87,518.15,524.25,440.49,524.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059990642152859784330000013703954032791319472_",
    gradientUnits: "userSpaceOnUse",
    x1: 498.713,
    y1: 499.1919,
    x2: 498.713,
    y2: 365.932
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FED702"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAA00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059990642152859784330000013703954032791319472_)"
    },
    d: "M623.82,435.87      c-21.11-44.44-66.41-75.25-118.78-75.25c-72.46,0-131.42,58.96-131.42,131.43c0,8.09,0.77,15.99,2.18,23.69      c20.41,5.53,42.15,8.53,64.7,8.53C518.15,524.25,586.16,488.87,623.82,435.87z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "610.66,458.66 588.91,454.61 536.88,444.93 501.03,379.01 465.18,444.93 413.15,454.61     391.41,458.66 443.03,513.13 433.28,587.53 501.03,555.27 568.79,587.53 559.04,513.13   "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041985262345070937990000016615353210497344902_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.3408,
    y1: 614.5859,
    x2: 506.3408,
    y2: 430.0952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2582,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000041985262345070937990000016615353210497344902_)"
    },
    points: "614.5,451.09 593.04,447.1      541.71,437.55 506.34,372.51 470.97,437.55 419.64,447.1 398.18,451.09 449.11,504.83 439.49,578.24 506.34,546.41      573.19,578.24 563.57,504.83    "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119820150317678713670000011224182774663577279_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.3408,
    y1: 395,
    x2: 506.3408,
    y2: 606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119820150317678713670000011224182774663577279_)"
    },
    d: "M506.34,495.18    c32.66,0,61.49-16.4,78.71-41.42l-46.6-8.67l-32.11-59.04l-32.11,59.04l-46.6,8.67C444.85,478.78,473.68,495.18,506.34,495.18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunCoin);
export default __webpack_public_path__ + "static/media/fun-coin.4d96c2fc19714b9cbb7755bbc80fd25a.svg";
export { ForwardRef as ReactComponent };